import React from 'react';
import {Button, FlexRow,} from 'ui-toolkit';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBan} from '@fortawesome/pro-regular-svg-icons';

interface ICancelOrderButtonBlockProps {
  orderCancelled: boolean;
  onCancelButtonClick: () => void;
}
// Child of the ClientOrder to cancel an order.
// May display information about a cancellation in progress.
export const CancelOrderButtonBlock: React.FC<ICancelOrderButtonBlockProps> = ({
  onCancelButtonClick,
  orderCancelled,
}) => {
  return (
    <>
      {!orderCancelled && (
        <FlexRow justifyContent={'flex-end'}>
          <Button isInline intent={'danger'} onClick={onCancelButtonClick}>
            <span>
              <FontAwesomeIcon icon={faBan} />
            </span>
            Cancel Order
          </Button>
        </FlexRow>
      )}
    </>
  );
};
